import { render, staticRenderFns } from "./AmaLink.vue?vue&type=template&id=7cc0adcf&scoped=true&"
import script from "./AmaLink.vue?vue&type=script&lang=js&"
export * from "./AmaLink.vue?vue&type=script&lang=js&"
import style0 from "./AmaLink.vue?vue&type=style&index=0&id=7cc0adcf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc0adcf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2065084294/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cc0adcf')) {
      api.createRecord('7cc0adcf', component.options)
    } else {
      api.reload('7cc0adcf', component.options)
    }
    module.hot.accept("./AmaLink.vue?vue&type=template&id=7cc0adcf&scoped=true&", function () {
      api.rerender('7cc0adcf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AmaLink.vue"
export default component.exports